//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import TableComponentServerSingleWithFilter from '../../components/TableComponent/TableComponentServerSingleWithFilter.vue'

export default {
  name: 'ItemsSearchDialog',
  components: {
    TableComponentServerSingleWithFilter
  },
  props: {
    config: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      headerLabel: null,

      itemsList: null,
      store: null,
      multiple: null,

      onApply: null,
      onCancel: null,

      selectedItems: [],
      selectedItemsIds: [],

      columns: [
        {
          name: 'name',
          label: 'Название',
          align: 'left',
          defaultWidth: 130,
          field: 'name',
          sortable: true
        }
      ],
      searchColumns: [
        'name'
      ]
    }
  },
  watch: {
    config: {
      handler: function (config) {
        if (config) {
          this.select(config)
        } else {
          // TODO ?
        }
      },
      immediate: true
    }
  },
  methods: {
    select: function (config) {
      this.itemsList = config.value || []
      this.store = config.store // TODO required
      this.multiple = !!config.multiple

      this.headerLabel = config.headerLabel || (this.multiple ? 'ВЫБОР ЗНАЧЕНИЙ' : 'ВЫБОР ЗНАЧЕНИЯ')

      this.onApply = config.onApply // TODO required
      this.onCancel = config.onCancel || (() => {})

      this.selectedItems = this.itemsList.slice()
      this.selectedItemsIds = this.itemsList.map(item => item.id)

      // this.show()
    },
    apply: function (value) {
      this.onApply(value)
    },

    onCancelSelection: function () {
      this.selectedItems = []
      this.selectedItemsIds = []
      this.closeSelectionDialog()
    },
    onItemSelected: function (item) {
      if (this.multiple) {
        const itemIndex = this.selectedItemsIds.indexOf(item.id)
        if (itemIndex === -1) {
          // Ищем среди старых значений
          const itemOld = this.itemsList.find(itemOld => itemOld.id === item.id)
          if (itemOld) {
            item = itemOld
          }
          this.selectedItemsIds.push(item.id)
          this.selectedItems.push(item)
        } else {
          this.selectedItemsIds.splice(itemIndex, 1)
          this.selectedItems.splice(itemIndex, 1)
        }
      } else {
        this.onItemsSelected(item ? [item] : [])
      }
    },
    onItemsSelected: function (items) {
      this.selectedItems = items
    },
    onClearSelection: function () {
      this.selectedItemsIds = []
      this.selectedItems = []
    },
    onSaveSelection: function () {
      this.apply(this.selectedItems)
      this.closeSelectionDialog()
    },
    closeSelectionDialog: function () {
      this.hide()
      // TODO
      // this.$nextTick(() => {
      //   this.blurField()
      // })
    },

    // following methods are REQUIRED ===
    show () {
      this.$refs.dialog.show()
    },
    hide () {
      this.$refs.dialog.hide()
    },
    // ===

    onDialogHide () {
      this.$emit('hide') // REQUIRED to be emitted, when QDialog emits "hide" event
    },
    onOKClick () {
      this.$emit('ok') // REQUIRED; or with payload: this.$emit('ok', { ... })
      this.hide()
    },
    onCancelClick () {
      this.hide()
    }
  }
}
